import React from "react";
import "./ValueSection.css";
import Science from "../assets/images/Science.svg"
import Societal from "../assets/images/Societal.svg"
import System from "../assets/images/System.svg"
import { motion } from "framer-motion";

const ValueSection = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 80 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      viewport={{ once: false, amount: 0.3 }}
    >
    <section className="value-section">
      <div className="value-container">

        <div className="value-item">
          <img src={Science} alt="Science" />
          <h3>Science</h3>
          <p>Rigorous spatial and AI research</p>
        </div>

        <div className="value-item">
          <img src={Societal} alt="Societal Impact"/>
          <h3>Societal Impact</h3>
          <p>Measurable benefits for citizens and policymakers</p>
        </div>

        <div className="value-item">
          <img src={System} alt="System"/>
          <h3>System</h3>
          <p>Scalable, interoperable technology</p>
        </div>
      </div>
      </section>
    </motion.section>
  );
};

export default ValueSection;
